import React, { useEffect } from 'react';
import { Grid, Tooltip, Typography, Chip, Box, IconButton } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import SelectDateModal from '../../paymentrequests/components/SelectDateModal';
import moment from 'moment';
import CalendarIcon from '../../../icons/CalendarIcon.svg';

interface DateConfigProps {
  name: string;
  label: string;
  description: string;
  onChange: (ConfigTypeKey1: string, AssignedValue1: any, ConfigTypeKey2?: string, AssignedValue2?: any) => void;
  dateConfigValue: string | undefined; //has to be a date string in format yyyy-mm-dd
  minDate?: Date | undefined; // optional: minimum date that should be available on the modal
}

const DateConfig = (props: DateConfigProps) => {
  const { name, label, description, onChange, dateConfigValue } = props;
  const [date, setDate] = React.useState<Date | null>(null);
  const [openDateModal, setOpenDateModal] = React.useState(false);

  useEffect(() => {
    if (!!dateConfigValue) {
      let year = parseInt(dateConfigValue?.slice(0, 4) ?? '');
      let month = parseInt(dateConfigValue?.slice(5, 7) ?? '');
      let day = parseInt(dateConfigValue?.slice(8, 10) ?? '');
      let configDate = new Date(year, month - 1, day);
      setDate(configDate);
    }
  }, [dateConfigValue]);

  return (
    <Grid container sx={{ pt: 1.5, pb: 1.5 }}>
      <Grid item sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <Tooltip title={description} placement="right">
          <HelpIcon sx={{ fontSize: 16, color: '#C4C4C4', cursor: 'pointer', mr: '9px' }} />
        </Tooltip>
        <Typography
          sx={{
            fontFamily: 'Work Sans',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '22px',
          }}
        >
          {label}
        </Typography>
        <Grid item display="flex" ml={2} alignItems="center">
          <Chip label={date ? moment(date).format('MM/DD/YYYY') : ''} />
          <Box style={{ marginRight: '24px' }}>
            <IconButton aria-label="calendar" onClick={() => setOpenDateModal(true)}>
              <img src={CalendarIcon} alt="calendar icon" width="24px" height="24px" />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
      <SelectDateModal
        date={date}
        isInvisible={false}
        onChangeDate={(newDate) => {
          setDate(newDate);
          onChange(name, moment(newDate)?.format('YYYY-MM-DD'));
        }}
        open={openDateModal}
        onClose={() => {
          setOpenDateModal(false);
        }}
        minDate={props.minDate}
      />
    </Grid>
  );
};

export default DateConfig;
